import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import 'tippy.js/animations/shift-toward.css';

export default class CabinetPointers {
    constructor(container) {
        this.pointsData = JSON.parse(container.dataset.points);
        this.container = container;
        this.pointers = container.querySelectorAll('.pointer-bubble');
        this.tippyInstances = []; // Array to store all tippy instances
        this.mobileInfoBoxes = document.querySelectorAll('.info-box-mobile');
        this.currentWidth = window.innerWidth;
        this.init();
    }

    initTooltips() {
        if (this.currentWidth <= 500) {
            // Destroy any existing tippy instances if screen is too narrow
            this.destroyTippyInstances();
            return;
        }

        this.pointers.forEach((pointer, index) => {
            const pointData = this.pointsData[index];
            const toolttipPlacement = pointer.dataset.placement || 'top';

            if (!pointData) {
                return;
            }

            const tooltipContent = `
                ${pointData?.image ? `<img src="${pointData.image}" alt="${pointData?.list_title || ''}" class="tooltip-image" />` : ''}
                ${pointData?.list_title ? `<p class="tooltip-title">${pointData.list_title}</p>` : ''}
                ${pointData?.list_items?.length ? `
                    <ul>
                        ${pointData.list_items.map(item => item ? `<li>${item}</li>` : '').join('')}
                    </ul>
                ` : ''}
            `.trim();

            const instance = tippy(pointer, {
                content: tooltipContent,
                allowHTML: true,
                placement: toolttipPlacement + '-start',
                arrow: false,
                theme: 'custom',
                animation: 'shift-toward',
                trigger: 'click',
                duration: 300,
                hideOnClick: true,
                flip: true,
                popperOptions: {
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: ['left-start', 'right-start', 'top', 'bottom'],
                            },
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: 'viewport',
                            },
                        }
                    ],
                },
                onCreate: () => {
                    // Add click handler for the pointer
                    pointer.addEventListener('click', () => this.handlePointerClick(index));
                }
            });

            this.tippyInstances.push(instance);
        });
    }

    handlePointerClick(index) {
        // Handle mobile info boxes
        if (this.currentWidth <= 500) {
            this.mobileInfoBoxes.forEach(box => {
                if (box.dataset.pointer === index.toString()) {
                    // Remove active class from all boxes
                    this.mobileInfoBoxes.forEach(b => b.classList.remove('active'));
                    // Add active class to the clicked box
                    box.classList.add('active');

                    // Scroll to the top of the box
                    /* box.scrollIntoView({ behavior: 'smooth', block: 'start' }); */
                    window.scrollTo({
                        top: box.getBoundingClientRect().top + window.scrollY - 200,
                        behavior: 'smooth'
                    });

                }
            });
        }
    }

    destroyTippyInstances() {
        this.tippyInstances.forEach(instance => {
            instance.destroy();
        });
        this.tippyInstances = [];
    }

    handleResize() {
        const newWidth = window.innerWidth;

        // Only reinitialize if crossing the breakpoint
        if ((this.currentWidth <= 500 && newWidth > 500) ||
            (this.currentWidth > 500 && newWidth <= 500)) {
            this.currentWidth = newWidth;
            this.initTooltips();
        }
    }

    init() {
        this.initTooltips();

        // Add resize listener
        window.addEventListener('resize', () => {
            // Debounce resize handler
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.handleResize();
            }, 250);
        });

        // Add click handlers for pointers
        this.pointers.forEach((pointer, index) => {
            pointer.addEventListener('click', () => this.handlePointerClick(index));
        });
    }

    destroy() {
        // Clean up
        this.destroyTippyInstances();
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimeout);
    }
}